import React from 'react';
import { Link, Redirect } from "react-router-dom";
import { Typography, Table, Divider, Icon, notification, Popconfirm, Skeleton, Modal, message, Result } from 'antd';
import Highlighter from 'react-highlight-words';
import { Card, Avatar, List, Form, Input, Radio, DatePicker, Button, Spin } from 'antd';
import { observer } from "mobx-react";
import { autorun } from 'mobx';
import moment from 'moment';
import _ from 'lodash';

import { normalizeMatchPath, checkPrintingSanity, getDymoPrinterAndLabel, dymoPrintLabel } from './common';

import { ShippingItemStoreContext } from './AppContexts';

@observer
class ShippingItems extends React.Component {
	static contextType = ShippingItemStoreContext;

	state = {
		selectedRowKeys: []
		,selectedRows: []
		/*,pagination: { //moved to the context store
			pageSize: 50
		}*/
		//,filteredInfo: null //moved to the context store
		//,sortedInfo: null moved to the context store
	};
	searchInputs = {}

	componentDidMount() {
		//prevents re-fetching the store. You may want to use react-router-cache-route instead
		if (this.context.items.length == 0 || this.context.dirty || this.context.filtered){
			this.context.load(this.state, this.setPaginationInfo);
		}
		this.refetchOnInsertDisposer = autorun( () => { //this code reloads the list when something is inserted
			console.log('check if needs refetching the store');
			if (this.context.dirty){
				this.context.load(this.state, this.setPaginationInfo);
			}
		});
		//console.log(this);
	}

	setPaginationInfo = (total) => {
		//const pagination = { ...this.state.pagination };
		const pagination = { ...this.context._pagination };
		pagination.total = total;
		/*this.setState({
			pagination
		});*/
		this.context.setPagination(pagination);
		console.log('set pagination info', pagination);
	}

	componentWillUnmount() {
		console.log('ShippingItems componentWillUnmount');
		if (this.refetchOnInsertDisposer){
			this.refetchOnInsertDisposer();
		}
	}

	reloadStore = () => {
		this.context.load(this.state, this.setPaginationInfo);
	}

	clearTableSelections = () => {
		this.setState({
			selectedRowKeys: []
			,selectedRows: []
		});
	}

	deleteItem(item) {
		console.log(`removing ${item.id}`);
		this.context.delete(item.id).then( () => {
			notification.success({
				message: 'Success',
				description: 'Item deleted successfully',
				duration: 4
			});
			this.clearTableSelections();
		}).catch( (err) => {
			notification.error({
				message: 'Error',
				description: `Cannot delete the item. Please try again.\n${err && err.message || ''}`,
				duration: 8
			});
		});
	}

	onRowSelectChange = (selectedRowKeys, selectedRows) => {
		console.log(`selectedRowKeys: ${selectedRowKeys}`);
		let selectedRowsItems = this.context.allItemsWithoutPagination.filter( item => (selectedRowKeys.indexOf(item.id) !== -1) );
		this.setState({ selectedRowKeys: selectedRowKeys, selectedRows: selectedRowsItems });
	
	}

	getColumnSearchProps = dataIndex => ({
		filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
			<div style={{ padding: 8 }}>
				{ dataIndex == 'deliveryNoteId' ? <small>Insert -1 to search for empty values</small>: null }
				{ dataIndex != 'country' &&
				<Input
					ref={node => {
						this.searchInputs[dataIndex] = node;
					}}
					placeholder={`Search ${dataIndex}`}
					value={selectedKeys ? selectedKeys[0] : '' }
					onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
					onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
					style={{ width: 188, marginBottom: 8, display: 'block' }}
				/>
				}
				{ dataIndex == 'country' &&
				<Radio.Group className='radio-vertical'
					value={selectedKeys ? selectedKeys[0] : '' }
					onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [''])}
					options={[ { label: 'Italia', value: '=IT' }, { label: 'Fuori Italia', value: '!=IT' }, { label: 'Tutte', value: '' } ]}
				/> }
				<Button type="primary" onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
					icon="search"
					size="small"
					style={{ width: 90, marginRight: 8 }}
				>Search</Button>
				<Button onClick={() => this.handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
				Reset
				</Button>
			</div>
		),

		filteredValue: this.context._filteredInfo && this.context._filteredInfo[dataIndex] || null,

		filterIcon: filtered => (
			<Icon type="search" style={{ color: filtered ? '#ff4d4f' : undefined }} />
		),

		//onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()), //local filter

		onFilterDropdownVisibleChange: visible => {
			if (visible) {
				setTimeout(() => {
					if (!this.searchInputs[dataIndex]) {
						return;
					}
					this.searchInputs[dataIndex].select()
				});
			}
		},

		render: text => (
			(this.context._filteredInfo && this.context._filteredInfo[dataIndex] && this.context._filteredInfo[dataIndex].length > 0 && text) ?
				<Highlighter
					highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
					searchWords={this.context._filteredInfo[dataIndex]}
					autoEscape
					textToHighlight={text.toString()}
				/> : text
		),
	});

	handleSearch = (selectedKeys, confirm, dataIndex) => {
		confirm();
	};

	handleReset = (clearFilters, dataIndex) => {
		clearFilters();
		/*let filteredInfo = { ...this.state.filteredInfo };
		if (filteredInfo[dataIndex]){
			filteredInfo[dataIndex] = null;
		}
		console.log('new filteredinfo', filteredInfo);
		this.setState({
			filteredInfo
		});*/
	};

	handleTableChange = (pagination, filters, sorter) => {
		const pager = { ...this.context._pagination };
		pager.current = pagination.current;
		this.context.setPagination(pager);
		this.context.setSortedInfo(sorter);
		this.context.setFilteredInfo(filters);
		/*this.setState({
			//filteredInfo: filters,
			//sortedInfo: sorter,
			//pagination: pager,
		}, () => {
		});*/
		console.log(pagination);
		console.log(filters);
		console.log(sorter);
		console.log(this.state);
		setTimeout( () => {
			this.context.load(this.state, this.setPaginationInfo);
		}, 490);
	};

	generateDeliveryNotes = () => {
		this.context.generateDeliveryNotes(this.state.selectedRowKeys).then( (result) => {
			console.log('then block');
			if (result && result.stat == 'ok'){
				let subtitle = (<>
					<div>Sono state generate le seguenti Bolle: {result.deliveryNoteIds.join(', ')}</div>
					<div>{result.shippingItemsUpdated} colli sono stati aggiornati.</div>
				</>)
				Modal.success({
					content: (
						<Result status="success" title="Operazione effettuata con successo"
							subTitle={ subtitle }
						/>
					)
					,width: '60%'
				});
			}
			else {
				let subtitle = (<>
					{ result && result.errors ?
						(<>
							<div>Si sono verificati errori nell'eseguire la tua richiesta:</div>
							{ result.errors.map( (error, index) => (<div key={index}>{error}</div>) ) }
						</> ) : null
					}
					{ result && result.err ? <div>{ result.err }</div> : null }
					{ result && result.results ? 
						( <>
							<div>Queste Bolle sono state generate prima dell'errore: {result.results.deliveryNoteIds.join(', ')}.</div>
							<div>Si sono verificati errori processando la Bolla numero  {result.results.lastDeliveryNoteId}</div>
							<div>{result.results.shippingItemsUpdated} colli sono stati aggiornati prima dell'errore.</div>
						</> ) : null 
					}
					{ !result && 'Errore sconosciuto' }
				</>);
				Modal.error({
					content: (
						<Result status="error" title="Errore"
							subTitle={ subtitle }
						/>
					)
					,width: '60%'
				});
			}
			this.clearTableSelections();
			this.reloadStore();
		}).catch( (err) => {
			console.log('catch block');
			Modal.error({
				content: (
					<Result status="error" title="Errore"
						subTitle={ `${err && err.message || err}` }
					/>
				)
				,width: '60%'
			});
		});
	}

	deleteDeliveryNoteConfirm = () => {
		Modal.confirm({
			title: 'Inserisci il numero della Bolla che vuoi eliminare',
			content: (
				<Input type="text" placeholder="numero bolla" onChange={ (e) => { this.setState({ deliveryNoteIdToBeDeleted: e.currentTarget.value }) } } />
			),
			onOk: () => {
				Modal.confirm({
					title: 'Conferma',
					content: `Sei sicuro di voler eliminare la bolla n° ${this.state.deliveryNoteIdToBeDeleted}?`,
					onOk: () => {
						this.deleteDeliveryNote();
					},
					onCancel: () => {
						this.setState({ deliveryNoteIdToBeDeleted: null });
					}
				});
			},
			onCancel: () => {
				this.setState({ deliveryNoteIdToBeDeleted: null });
			},
		});
	}

	deleteDeliveryNote = () => {
		this.clearTableSelections();
		console.log('delete delivery note');
		if (this.state.deliveryNoteIdToBeDeleted){
			this.context.deleteDeliveryNote(this.state.deliveryNoteIdToBeDeleted).then( (result) => {
				if (result && result.count){
					message.success({ content: `${result.count} colli sono stati aggiornati`, duration: 5 });
					return;
				}
				message.warning({ content: `Nessun collo è stato aggiornato!`, duration: 5 });
			}).then( () => {
				this.reloadStore();
			}).catch( (err) => {
				message.error({ content: `C'è stato un errore: ${err ? err.message : err}`, duration: 5 });
			});
			this.setState({ deliveryNoteIdToBeDeleted: null });
		}
	}

	printOnA4 = () => {
		let selectedRowKeys = this.state.selectedRowKeys;
		let selectedRowsItems = this.context.allItemsWithoutPagination.filter( item => (selectedRowKeys.indexOf(item.id) !== -1) );
		console.log(selectedRowsItems);
		let errors = checkPrintingSanity(selectedRowsItems);
		
		if (errors.length > 0){
			Modal.error({
				content: (<> 
					<h3>Non puoi stampare perchè ci sono colli incompleti:</h3>
					{ errors.map( (error, ndx) => <div key={ndx}>{error}</div>) }
				</>)
				,width: '60%'
			});
			return;
		}
		this.context.setPrintableItems(selectedRowsItems);
		this.setState({
			redirectTo: '/shipping-items/printA4'
		});
	}

	printOnDymo = () => {
		let selectedRowKeys = this.state.selectedRowKeys;
		let selectedRowsItems = this.context.allItemsWithoutPagination.filter( item => (selectedRowKeys.indexOf(item.id) !== -1) );
		let errors = checkPrintingSanity(selectedRowsItems);

		this.clearTableSelections();
		if (errors.length > 0){
			Modal.error({
				content: (<> 
					<h3>Non puoi stampare perchè ci sono colli con dati incompleti:</h3>
					{ errors.map( (error, ndx) => <div key={ndx}>{error}</div>) }
				</>)
				,width: '60%'
			});
			return;
		}

		getDymoPrinterAndLabel().then( (printInfo) => {
			let promise = Promise.resolve();
			let total = selectedRowsItems.length;
			var labelTemplate = _.template(printInfo.labelTemplate);
			//console.log(printInfo);
			selectedRowsItems.forEach( (item, index) => {
				promise = promise.then( () => {
					let labelXml = labelTemplate(item);
					//console.log(labelXml);
					return dymoPrintLabel({ labelXml: labelXml, printerName: printInfo.printerName }).then( (result) => {
						console.log(result);
						return message.loading(`Printing label ${index+1} out of ${total}`, 1);
					});
				});
			});
			return promise;
		}).then( () => {
			Modal.success({
				title: 'Risultato di stampa'
				,content: 'Le etichette selezionate sono state mandate in stampa.'
				,onOk() {}
			});
		}).catch( (err) => {
			Modal.error({
				title: 'Errore di stampa'
				,content: `Errore nella stampa delle etichette: ${ typeof err == 'object' && err.message ? err.message : err }`
				,onOk() {}
			});
		});

	}

	exportData = () => {
		let selectedRowKeys = this.state.selectedRowKeys;
		let selectedRowsItems = this.context.allItemsWithoutPagination.filter( item => (selectedRowKeys.indexOf(item.id) !== -1) );
		console.log(selectedRowsItems);
		let errors = checkPrintingSanity(selectedRowsItems, {checkPackagesCompleteness: true});
		
		if (errors.length > 0){
			Modal.error({
				content: (<> 
					<h3>Non puoi esportare perchè ci sono colli con dati incompleti o incongruenti:</h3>
					{ errors.map( (error, ndx) => <div key={ndx}>{error}</div>) }
				</>)
				,width: '60%'
			});
			return;
		}
		this.context.setPrintableItems(selectedRowsItems);
		this.setState({
			redirectTo: '/shipping-items/export-spreadsheets'
		});
	}

	toggleDeliveryNoteIDFilter = () => {
		let pagination = { ...this.context._pagination };
		pagination.current = 1;
		new Promise( (resolve, reject) => {
			this.context.setPagination(pagination);
			if (this.context._filteredInfo
			    && this.context._filteredInfo.deliveryNoteId && this.context._filteredInfo.deliveryNoteId.length > 0
			){
				//has filter, removing it...
				let filteredInfo = { ...this.context._filteredInfo, deliveryNoteId: null };
				this.context.setFilteredInfo(filteredInfo);
			}
			else {
				let filteredInfo = { ...this.context._filteredInfo, deliveryNoteId: ["-1"] };
				this.context.setFilteredInfo(filteredInfo);
			}
			setTimeout(350, resolve);
		}).then( () => {
			this.reloadStore();
		});
	}

	deleteSelectedItems = () => {
		let store = this.context;

		Modal.confirm({
			title: 'Conferma'
			,content: `Vuoi davvero eliminare i ${this.state.selectedRowKeys.length} colli selezionati?`
			,onOk: () => {
				this.state.selectedRowKeys.reduce( (promiseAccumulator, currentKey) => {
					return promiseAccumulator.then( (chainResults) => {
						return store.delete(currentKey).then( (currentResult) => {
							return [...chainResults, currentResult];
						})
					} );
				}, Promise.resolve([]) ).then(arrayOfResults => {
					notification.success({
						message: 'Operazione conclusa',
						description: 'Gli elementi selezionati sono stati eliminati con successo',
						duration: 4
					});
				}).catch( (err) => {
					notification.error({
						message: 'Errore',
						description: `Si sono verificati degli errori durante la rimozione degli elementi: \n${err && err.message || ''}`,
						duration: 8
					});
				}).then( () => {
					this.clearTableSelections();
					this.reloadStore();
				});
			}
		});
	}

	getTextualFilterInfo() {
		const removeAllFilters = () => {
			let pagination = { ...this.context._pagination };
			pagination.current = 1;
			this.context.setFilteredInfo(null);
			this.context.setPagination(pagination);
			setTimeout( () => {
				this.reloadStore();
			}, 350);
		}

		const getFilterValue = (key) => {
			if (key != 'country' && key != 'deliveryNoteId') {
				return this.context._filteredInfo[key];
			}
			let val = this.context._filteredInfo[key];
			if (key == 'country') {
				if (val == '=IT') {
					return 'solo Italia';
				}
				else if (val =='!=IT') {
					return 'fuori Italia';
				}
				return 'tutte';
			}
			if (key == 'deliveryNoteId') {
				if (val == -1) {
					return 'elementi ancora da assegnare';
				}
				else if (val > 0) {
					return val;
				}
				return 'tutte';
			}
		}

		const FILTER_KEY_TO_NAME = {
			deliveryNoteId: 'bolla'
			,client: 'cliente'
			,recipient: 'destinatario'
			,attention: 'att.ne'
			,address: 'indirizzo'
			,zip: 'cap'
			,city: 'città'
			,country: 'nazione'
		};
		let filterEmpty = true;
		if (!this.context._filteredInfo) {
			return null;
		}
		console.log(this.context._filteredInfo);
		let filterDesc = Object.keys(this.context._filteredInfo).map( (filterKey) => {
			if (this.context._filteredInfo[filterKey] == null || this.context._filteredInfo[filterKey][0] == ''
				|| this.context._filteredInfo[filterKey].length == 0
			) {
				return null;
			}
			filterEmpty = false;
			return <span key={filterKey}>{FILTER_KEY_TO_NAME[filterKey] || filterKey}=<strong>{getFilterValue(filterKey)}</strong></span>
		});

		return filterEmpty ?
			null 
			:( <div className='filter-summary'>
				Filtri attivi:{filterDesc} &nbsp;&nbsp;<Button type='link' icon='delete' onClick={removeAllFilters} />
			</div>)
		;
	}

	render() {
		if (this.state.redirectTo){
			return (
				<Redirect to={`${normalizeMatchPath(this)}${this.state.redirectTo}`} />
			);
		}

		const hasDeliveryNoteIdFilter = (this.context._filteredInfo
			&& this.context._filteredInfo.deliveryNoteId && this.context._filteredInfo.deliveryNoteId.length > 0);

		const columns = [
			{ title: 'Bolla', dataIndex: 'deliveryNoteId', key: 'deliveryNoteId', ...this.getColumnSearchProps('deliveryNoteId') }
			,{ title: 'Cliente', dataIndex: 'client', key: 'client', ...this.getColumnSearchProps('client') }
			,{ title: 'Destinatario', dataIndex: 'recipient', key: 'recipient', ...this.getColumnSearchProps('recipient') }
			,{ title: 'Att.ne', dataIndex: 'attention', key: 'attention', ...this.getColumnSearchProps('attention') }
			,{ title: 'Indirizzo', dataIndex: 'address', key: 'address', ...this.getColumnSearchProps('address') }
			,{ title: 'CAP', dataIndex: 'zip', key: 'zip', ...this.getColumnSearchProps('zip') }
			,{ title: 'Città', dataIndex: 'city', key: 'city', ...this.getColumnSearchProps('city') }
			//,{ title: 'Prov IT', dataIndex: 'provinceIT', key: 'provinceIT' }
			,{ title: 'Nazione', dataIndex: 'country', key: 'country', ...this.getColumnSearchProps('country') }
			//,{ title: 'Tel', dataIndex: 'phone', key: 'phone' }
			,{ title: 'Peso', dataIndex: 'grossWeight', key: 'grossWeight' }
			,{ title: 'Descrizione', dataIndex: 'description', key: 'description' }
			,{ title: 'Collo', dataIndex: 'packageSeq', key: 'packageSeq' }
			,{ title: 'Tot colli', dataIndex: 'packagesTot', key: 'packagesTot' }
			,{ title: 'Azioni', key: '_action', 
				render: (text, record) => (
					<span>
					    <Link to={`${normalizeMatchPath(this)}/shipping-items/view/${record.id}`}><Icon type="edit" /></Link>
					    <Divider type="vertical" />
					    <Popconfirm title="Do you really want to delete this item?" onConfirm={ () => this.deleteItem(record) } okText="Yes" cancelText="No">
						<a href="#"><Icon type="delete" /></a>
					    </Popconfirm>
					</span>
				),
			}
		];
		//console.log(this.props);
		const rowSelection = {
			selectedRowKeys: this.state.selectedRowKeys
			,onChange: this.onRowSelectChange
		};
		const hasSelected = this.state.selectedRowKeys.length > 0;
		//this.context.items.slice() in the <Table> component is required to trigger re-rendering

		return (
		<>
			<Typography.Title level={3}>Bolle e Colli</Typography.Title>
			<Typography.Paragraph className='text-right'>
				<Link to={`${normalizeMatchPath(this)}/shipping-items/new`}><Button icon='plus' size='default' type='primary'>aggiungi collo</Button></Link>
			</Typography.Paragraph>
			{ this.context.isLoading ? (
			<>
				<Skeleton active paragraph={{ rows: 1 }} />
				<Skeleton active paragraph={{ rows: 1 }} />
				<Spin size="default" tip="Loading..." />
			</>
			) : null }
			{ !this.context.isLoading && (
			<>
				{ this.context._filteredInfo && this.getTextualFilterInfo() }
				<div style={{ marginBottom: 16 }}>
					<Button type="primary" onClick={ this.toggleDeliveryNoteIDFilter }
						title={hasDeliveryNoteIdFilter ? 'Mostra tutti gli elementi' : 'Mostra solo gli elementi ancora da assegnare'}
						style={{ marginRight: 8 }} icon={ hasDeliveryNoteIdFilter ? 'eye-invisible' : 'eye' }></Button>
					<Button type="primary" disabled={!hasSelected} onClick={ this.generateDeliveryNotes } style={{ marginRight: 8 }} icon="tags">
						Genera n° Bolle e Colli
					</Button>
					<Button type="primary" disabled={!hasSelected} onClick={ this.exportData } style={{ marginRight: 8 }} icon="export">
						Esporta... 
					</Button>
					<Button type="primary" disabled={!hasSelected} onClick={ this.printOnDymo } style={{ marginRight: 8 }} icon="barcode">
						Stampa su DYMO
					</Button>
					<Button type="primary" disabled={!hasSelected} onClick={ this.printOnA4 } style={{ marginRight: 8 }} icon="printer">
						Stampa su A4
					</Button>
					<Button type="danger" disabled={!hasSelected} onClick={ this.deleteSelectedItems } style={{ marginRight: 8 }} icon="delete">
						Elimina Colli
					</Button>
					<Button type="default" disabled={this.context.isLoading} style={{ marginLeft: 32 }} onClick={ this.deleteDeliveryNoteConfirm } icon="close">
						Elimina n° Bolla
					</Button>
					<Button type="default" disabled={this.context.isLoading} style={{ marginLeft: 8 }} onClick={ this.reloadStore } icon="reload">
						Ricarica
					</Button>
					<span style={{ marginLeft: 8 }}>
						{ hasSelected ? `Selected ${this.state.selectedRowKeys.length} items` : ''}
					</span>
				</div>
				<Table rowKey='id' dataSource={this.context.items.slice()} columns={columns} rowSelection={rowSelection}
					pagination={this.context._pagination} loading={this.context.isLoading} onChange={this.handleTableChange} />
			</>
			) }
		</>
		)
	}
}

export { ShippingItems };
